package com.milta.feature.delivery.domain.entity

data class AddressSuggestion(
    val label: String,
    val latitude: Double,
    val longitude: Double,
)
